export default {
  ACTIVE: 'active',
  TRIALING: 'trialing',
  DELETED: 'deleted'
}
